import React from 'react';
import NavbarTop from '../components/NavbarTop';
import NavbarBottom from '../components/NavbarBottom';
import AddUserForm from '../components/AddUserForm';

const UserAdd = () => {
  return (
    <div>
      <NavbarTop />
      <AddUserForm />
      <NavbarBottom />
    </div>
  );
};

export default UserAdd;
